import React from "react"
import { Link } from "gatsby"
import makeStyles from "@material-ui/core/styles/makeStyles"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import MuiLink from "@material-ui/core/Link"
import Button from "../../bits/Button"
import ScrollButton from "../../bits/ScrollButton"
import BackgroundVideo from "../../bits/BackgroundVideo"
import Form from "../../bits/Form"
import clsx from "../../../util/clsx"

const useStyles = makeStyles(theme => ({
  Section: {
    position: "relative",
    background: "rgba(255,255,255, 0.4)",
    padding: theme.spacing(2, 1),
    maxHeight: "fit-content",
    textAlign: "center",
    boxSizing: "border-box",

    "&:before": {
      position: "absolute",
      content: `''`,
      width: "100%",
      height: "100%",
      background:
        "linear-gradient(180deg, transparent, transparent,transparent, #ffe, #fff)",
      top: 0,
      right: 0,
      letf: 0,
      bottom: 0,
      zIndex: 1,
      transformOrigin: "bottom right",
      transform: "skewY(-2deg)",
    },
  },
  viewportHeader: {
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  GridContainer: {
    zIndex: 4,
    background: "transparent",
    position: "relative",
    display: "grid",
    padding: "auto",
    gridTemplateColumns: `1fr 1fr`,
    gap: theme.spacing(3),
    placeContent: "center / center",
    justifyItems: "space-around",

    maxWidth: 1200,
    width: "100%",
    margin: "auto",
    boxSizing: "border-box",
    [theme.breakpoints.down(700)]: {
      gap: theme.spacing(3),
      gridTemplateRow: "auto",
      gridTemplateColumns: "unset",
      textAlign: "center",
    },
    "& h1": {
      fontFamily: "Montserrat Alternates, sans-serif",
      fontSize: theme.typography.fontSize + 17,
      fontWeight: 800,
      marginBottom: theme.spacing(2),
      paddingTop: theme.spacing(10),
      [theme.breakpoints.down("xs")]: {
        fontSize: theme.typography.fontSize + 15,
        padding: theme.spacing(10, 4, 0, 4),
      },
    },
  },
  GridItem: {},
  GridItem_I: {
    margin: "auto",
    maxWidth: 743,
  },
  GridItem_II: {
    justifySelf: "center",
    alignSelf: "center",
    textAlign: "center",
    "& #message": {
      textAlign: "start",
    },
  },
  GridItem_III: {},
  ScrollButton: {
    position: "relative",
    zIndex: 1,
  },
}))
export default () => {
  const classes = useStyles()

  return (
    <Box
      className={clsx([classes.Section, classes.viewportHeader])}
      component="section"
    >
      <BackgroundVideo _mp4_src="gloone_events_op.mp4" />
      <Box className={classes.GridContainer}>
        <Box className={clsx([classes.GridItem, classes.GridItem_I])}>
          <Typography variant="h1" className={classes.h1}>
            A great event starts with the right catering service!
          </Typography>
          <Typography paragraph>
            Welcome to your one stop shop for event planning, catering, and
            design, where memorable events are carefully strategized to the best
            of your budget
          </Typography>
          <Box p={0}>
            <Button component={Link} to="#about">
              Discover
            </Button>
            <Button
              component={MuiLink}
              href="https://api.whatsapp.com/send?phone=2348139377764"
              target="_blank"
              rel="noopener noreferrer"
              aria_label="Gloone events Whatsapp contact number"
              secondary
              whatsapp
            >
              <Typography>Call +234 8139377764</Typography>
            </Button>
          </Box>
        </Box>
        <Box className={clsx([classes.GridItem, classes.GridItem_II])}>
          <Form />
        </Box>
      </Box>
      <Box pt={6} className={classes.ScrollButton}>
        <ScrollButton />
      </Box>
    </Box>
  )
}
